// #region USERS
export const USERS = {
  SIGNUP: '/users/signup',
  LOGIN: '/users/login',
  FORGOT_PASSWORD: '/users/identify',
  RESET_PASSWORD: '/users/reset-password',
  UPDATE_PASSWORD: '/users/update-password',
  UPDATE_PROFILE: '/users',
  VERIFY: '/users/verify',
  RESEND: '/users/resend-signup-activation',
  GET_ALL: '/users',
  GET_BY_ID: (id) => `/users/${id}`,
  GET_ME: '/users/me',
  GOOGLE_AUTH_CALLBACK: (queryString) => `/users/auth/google/callback${queryString}`,
};
// #endregion

// #region PROJECT_PROPOSALS
export const PROJECT_PROPOSALS = {
  GET_ALL: '/project-proposals',
  GET_BY_SEARCH_NAME: '/project-proposals/search',
  GET_REFERENCE: (id) => `/project-proposals/reference/${id}`,
  GET_ALL_VERSIONS: (id) => `/project-proposals/${id}/all-versions`,
  GET_TIME_LINE: (id) => `/project-proposals/${id}/time-line`,
  GET_GENERAL_INFO_BY_ID: (id) => `/project-proposals/general-info/${id}`,
  GET_RESEARCH_RESULT_BY_ID: (id) => `/project-proposals/research-result/${id}`,
  GET_EXPENDITURE_BY_ID: (id) => `/project-proposals/expenditure/${id}`,
  GET_DOCUMENTS_BY_ID: (id) => `/project-proposals/file-urls/${id}`,
  GET_OVERVIEW_BY_ID_FOR_COUNCIL: (id) => `/project-proposals/${id}/council`,
  GET_ALL_RESEARCH_TYPES: '/project-proposals/research-types',
  GET_ALL_RESEARCH_FIELDS: '/project-proposals/research-fields',
  GET_ALL_PROJECT_ROLES: '/project-proposals/project-roles',
  GET_OWNER: '/project-proposals/owner',
  GET_ALL_RESEARCH_KPIS: '/project-proposals/research-kpis',
  GET_RETRIEVE_CONTACTS: '/project-proposals/contacts',
  GET_ALL_ORGANIZATIONS: '/project-proposals/organizations',
  GET_ALL_PROPOSED_EXPENDITURE_TYPES: '/project-proposals/proposed-expenditure-types',
  GET_ALL_STASTUSES: '/project-proposals/statuses',
  CREATE: '/project-proposals',
  UPDATE: (id) => `/project-proposals/${id}`,
  UPDATE_STATUS: (id) => `/project-proposals/${id}/status`,
  GET_REVISE_LOGS: (id) => `/project-proposals/revise-log/${id}`,
  REQUEST_UPDATE: '/project-proposals/open-revise',
  UPDATE_UPDATE_REQUEST: '/project-proposals/request-update/update',
  REQUEST_EXPLANATION: '/project-proposals/request-explanation',
  UPDATE_EXPLANATION_REQUEST: '/project-proposals/request-explanation/update',
  APPROVE: (id) => `/project-proposals/approve/${id}`,
  DELETE: (id) => `/project-proposals/${id}`,
  RESTORE: (id) => `/project-proposals/restore/${id}`,
  CHANGE_DEADLINE: '/project-proposals/change-deadline',
  UPLOAD_FILES: (id) => `/project-proposals/${id}/files`,
  GET_FILE_URLS: (id) => `/project-proposals/file-urls/${id}`,
  DOWNLOAD_FILE: '/project-proposals/download-file',
  DOWNLOAD_SCIENTIFIC_PROFILE_FILE: '/project-proposals/download-scientific-profile',
  EXPORT_EXCEL: '/project-proposals/export-file-excel/',
  OPEN_REVISES: '/project-proposals/open-revises/',
  GET_GENERAL_INFO_FOR_COUNCIL: (id) => `/project-proposals/general-info-for-council/${id}`,
  // Compare version
  GET_GENERAL_INFO_BY_VERSION: (id) => `/project-proposals/general-info/${id}/compare-version`,
  GET_RESEARCH_RESULT_BY_VERSION: (id) =>
    `/project-proposals/research-result/${id}/compare-version`,
  GET_EXPENDITURE_BY_VERSION: (id) => `/project-proposals/expenditure/${id}/compare-version`,
  GET_DOCUMENTS_BY_VERSION: (id) => `/project-proposals/file-urls/${id}/compare-version`,

  DOWNLOAD_ZIP: '/project-proposals/download-zip',
  DOWNLOAD_EXPLANATION: (id) => `/project-proposals/download-explanation/${id}`,
  SEND_REMIND_EMAIL: '/project-proposals/remind-mail',
  GET_EMAIL_LOGS_BY_ID: (id) => `/project-proposals/email-logs/${id}`,
  GET_PROJECT_LOGS_BY_ID: (id) => `/project-proposals/${id}/project-logs`,
  GET_PRODUCTS: '/project-proposals/products',
  SEARCH_FOR_COUNCIL: '/project-proposals/search-for-council',
  REQUEST_UPDATE_TYPE: '/project-proposals/request-update-type',
  CHANGE_PROGRAM: (id) => `/project-proposals/${id}/change-program`,
  DOWNLOAD_PDF: (id) => `/project-proposals/${id}/pdf-file`,
};
// #endregion

export const PUB_PROJECT_PROPOSALS = {
  GET_ALL: '/pub-project-proposals',
  GET_ALL_VERSIONS: (id) => `/pub-project-proposals/${id}/all-versions`,
  GET_GENERAL_INFO_BY_ID: (id) => `/pub-project-proposals/general-info/${id}`,
  GET_RESEARCH_RESULT_BY_ID: (id) => `/pub-project-proposals/research-result/${id}`,
  GET_EXPENDITURE_BY_ID: (id) => `/pub-project-proposals/expenditure/${id}`,
  APPROVE: (id) => `/pub-project-proposals/approve/${id}`,
};
// #endregion

// #region ORGANIZATIONS
export const ORGANIZATIONS = {
  GET_ALL: '/organizations',
  GET_ALL_BY_USER: '/organizations/me',
  GET_ALL_FOR_ADMINISTRATION: '/organizations/for-administration',
  GET_BY_ID: (id) => `/organizations/${id}`,
  CREATE: '/organizations',
  UPDATE: (id) => `/organizations/${id}`,
  DELETE: (id) => `/organizations/${id}`,
  RESTORE: (id) => `/organizations/${id}/restore`,
  REORDER: '/organizations/reorder',
};
// #endregion

// #region SCIENTIFIC_PROFILES
export const SCIENTIFIC_PROFILES = {
  UPLOAD_FILE: '/users/upload-file',
  DOWNLOAD_FILE: '/users/download-file',

  CREATE: '/scientific-profiles',
  UPDATE: '/scientific-profiles',

  GET_GENERAL_INFO: '/scientific-profiles/general-info',
  GET_ACADEMIC_HISTORY: '/scientific-profiles/academic-history',
  GET_WORK_HISTORY: '/scientific-profiles/work-history',
  GET_PROJECTS: '/scientific-profiles/projects',
  GET_THESIS_GUIDANCES: '/scientific-profiles/thesis-guidances',
  GET_SCIENTIFIC_WORKS: '/scientific-profiles/scientific-works',
  GET_OTHERS_INFO: '/scientific-profiles/others',

  CREATE_PUBLIC_PROFILE_ID: (id) => `/scientific-profiles/public-profile/${id}`,
};
// #endregion

// #region RESEARCH_TYPES
export const RESEARCH_FIELDS = {
  GET_ALL: '/research-fields',
  GET_ALL_BY_USER_ID: '/research-fields/for-user',
  GET_ALL_FOR_ADMINISTRATION: '/research-fields/for-administration',
  GET_BY_ID: (id) => `/research-fields/${id}`,
  CREATE: '/research-fields',
  UPDATE: (id) => `/research-fields/${id}`,
  DELETE: (id) => `/research-fields/${id}`,
  RESTORE: (id) => `/research-fields/${id}/restore`,
};
// #endregion

// #region EMPLOYEES
export const EMPLOYEES = {
  GET_ALL_ROLES: '/users/roles',
  GET_ALL: '/employees',
  GET_BY_ID: (id) => `/employees/${id}`,
  CREATE: '/employees/create',
  UPDATE: (id) => `/employees/${id}`,
  UPDATE_GENDER: (id) => `/employees/${id}/fields`,
  DELETE_BY_ID: (id) => `/employees/${id}`,
  RESET_PASSWORD: '/employees/reset-password',
  DOWNLOAD_SCIENTIFIC_PROFILE_FILE: '/employees/download-scientific-profile-file',
  EXPORT_EXCEL: '/employees/export_excel',
};
// #endregion

// #region COUNCILS
export const COUNCILS = {
  GET_ALL: '/councils',
  GET_ALL_BY_ID_PROJECT_PROPOSAL: (id) => `/councils/project-proposal/${id}`,
  POST_CREATE: '/councils',
  GET_BY_ID: (id) => `/councils/${id}`,
  GET_COUNCIL_MULTIPLE_PROJECTS_BY_ID: (id) => `/councils/multiple-projects/${id}`,
  DOWNLOAD_FILE: '/councils/download-file',
  DOWNLOAD_COUNCIL_MEMBER_EXCEL_FILE: (id, projectProposalId) =>
    `/councils/${id}/project-proposals/${projectProposalId}/download-council-member-excel-file`,
  PATCH_UPDATE_RESULT: '/councils/council-result',
  PATCH_UPDATE: '/councils',
  POST_SEND_MAIL_FINISH_MEMBERS: '/councils/members/mail',
  GET_ALL_COUNCIL_TYPES: '/councils/council-types',
  GET_ALL_COUNCIL_MEMBER_ROLES: '/councils/council-member-roles',
  POST_SEND_MAIL_REMIND_MEMBERS: '/councils/members/remind-mail',
  DELETE_BY_ID: (id) => `/councils/${id}`,
  CREATE_OR_UPDATE_PREQUALIFICATION_COUNCIL: '/councils/prequalification',
  GET_PREQUALIFICATION_COUNCIL_OF_PROJECT_PROPOSAL: '/councils/prequalification',
  GET_SPECIALIZATION_COUNCIL_OF_PROJECT_PROPOSAL: '/councils/specialization',
  GET_ACCEPTANCE_COUNCIL_OF_PROJECT: '/councils/acceptance',
  GET_LIQUIDATION_COUNCIL_OF_PROJECT: '/councils/liquidation',
  GET_FINANCE_COUNCIL_OF_PROJECT_PROPOSAL: '/councils/finance',
  GET_MIDTERN_REPORT_COUNCIL_OF_PROJECT: '/councils/midterm-report',
  POST_CHANGE_REQUEST_STATUS: '/councils/change-request-status',
  GET_MIDTERN_DOCUMENT_REVIEW: (id) => `/councils/midterm-document-review/${id}`,
  POST_MIDTERN_DOCUMENT_REVIEW: 'councils/midterm-document-review',
  POST_CREATE_FOR_MULTIPLE_PROJECTS: '/councils/multiple-projects',
  PATCH_EDIT_FOR_MULTIPLE_PROJECTS: '/councils/multiple-projects/1',
  GET_FOR_MULTIPLE_PROJECTS: (id) => `/councils/multiple-projects/${id}`,
  POST_SEND_MAIL_MULTIPLE_PROJECT: '/councils/multiple-projects/members/mail',
  POST_SEND_MAIL_REMIND_MULTIPLE_PROJECT: '/councils/multiple-projects/members/remind-mail',
  SEND_MAIL_COUNCIL_TO_MEMBER: (councilId, memberId) =>
    `/councils/${councilId}/members/${memberId}/mail`,
  SEND_MAIL_COUNCIL_HAS_PROJECTS_TO_MEMBER: (councilId, memberId) =>
    `/councils/${councilId}/multiple-projects/members/${memberId}/mail`,
  PATCH_UPDATE_MEMBER_ATTENDANCE: '/councils/members/attendance',
  GET_COUNCIL_MAIL_LOGS: (councilId) => `/councils/${councilId}/mail-logs`,
};
// #endregion

// #region PROGRAMS
export const PROGRAMS = {
  GET_ALL: '/programs',
  GET_ALL_BY_FILTER: '/programs/filter',
  GET_BY_ID: (id) => `/programs/${id}`,
  CREATE: '/programs',
  UPDATE: (id) => `/programs/${id}`,
  DELETE: (id) => `/programs/${id}`,
  SET_UNIT_PRE_QUALIFICATION_DEADLINES: (id) => `/programs/${id}/pre-qualification-deadlines`,
  GET_UNIT_PRE_QUALIFICATION_DEADLINES: (id) => `/programs/${id}/pre-qualification-deadlines`,
};
// #endregion

// #region PROPOSAL_PROGRAMS
export const PROPOSAL_PROGRAMS = {
  GET_ALL_BY_FILTER: '/proposal-programs',
  GET_ALL: '/proposal-programs',
  GET_ALL_WITH_NO_FILTER: '/proposal-programs/all',
  GET_BY_ID: (id) => `/proposal-programs/${id}`,
  CREATE: '/proposal-programs',
  UPDATE: (id) => `/proposal-programs/${id}`,
  DELETE: (id) => `/proposal-programs/${id}`,
};
// #endregion

// #region CONTACTS
export const CONTACTS = {
  GET_ALL: '/contacts',
  GET_BY_EMAIL: '/contacts/email',
  GET_MY_CONTACT: '/contacts/me',
  GET_BY_SEARCH_EMAIL: '/contacts/search',
  CREATE: '/contacts',
  UPDATE: '/contacts',
  UPLOAD_SIGNATURE: (id) => `/contacts/${id}/signature`,
  GET_SIGNATURE: (id) => `/contacts/${id}/signature`,
};
// #endregion

// #region STATISTICS
export const STATISTICS = {
  GET: '/statistics/common',
  GET_TOTAL_KPI: '/research-kpi-groups/totalReasearchKpiGroup',
  GET_TOTAL_EXPENDITURE: '/statistics/expenditure',
  GET_DETAIL_KPI: '/statistics/researchKpiGroup/',
  GET_YEARS: '/statistics/years',
  GET_ALL_USER_STATISTIC: '/statistics/users',
  GET_COUNCILS_BY_USER_ID: (userId) => `/statistics/users/${userId}/defense`,
};
// #endregion

// #region RESEARCH_KPI_GROUPS
export const RESEARCH_KPI_GROUPS = {
  GET_ALL: '/research-kpi-groups',
  GET_APPLIED_YEARS: '/research-kpi-groups/applied-years',
  CREATE: '/research-kpi-groups',
  CLONE: '/research-kpi-groups/clone',
  UPDATE: (id) => `/research-kpi-groups/${id}`,
  DELETE: (id) => `/research-kpi-groups/${id}`,
  RESTORE: (id) => `/research-kpi-groups/${id}/restore`,
};
// #endregion

// #region RESEARCH_KPIS
export const RESEARCH_KPIS = {
  GET_ALL: '/research-kpis',
  CREATE: '/research-kpis',
  UPDATE: (id) => `/research-kpis/${id}`,
  DELETE: (id) => `/research-kpis/${id}`,
  RESTORE: (id) => `/research-kpis/${id}/restore`,
  REORDER: '/research-kpis/reorder',
};
// #endregion

// #region PREQUALIFICATION_REVIEW
export const PREQUALIFICATION_REVIEW = {
  GET_PROJECT_PROPOSAL_INFO: '/prequalification-reviews/project-proposal',
  GET_REVIEWER_INFO: '/prequalification-reviews/reviewer',
  GET_DETAIL: '/prequalification-reviews/detail',
  CREATE: '/prequalification-reviews',
  UPDATE: '/prequalification-reviews',
  SUBMIT: '/prequalification-reviews/submit',

  GET_DETAIL_FILE: '/prequalification-reviews/detail/file-url',
  UPLOAD_DETAIL_FILE: '/prequalification-reviews/upload-file',
  UPDATE_DETAIL_FILE: '/prequalification-reviews/upload-file',
  DOWNLOAD_DETAIL_FILE: '/prequalification-reviews/download-file',
  SUBMIT_DETAIL_FILE: '/prequalification-reviews/submit',
  EXPORT_PDF_FILE: '/prequalification-reviews/export-pdf-file',
  DOWNLOAD_PDF_FILE: '/prequalification-reviews/download-pdf',
  DOWNLOAD_PDF_TEMPLATE: '/prequalification-reviews/download-pdf-template',
  DOWNLOAD_DOCX_FILE: '/prequalification-reviews/docx-file',
  DOWNLOAD_DOCX_TEMPLATE: '/prequalification-reviews/docx-template',
};
// #endregion
// #region SPECIALIZE_REVIEWS
export const SPECIALIZE_REVIEW = {
  GET_PROJECT_PROPOSAL_INFO: '/specialize-reviews/project-proposal',
  GET_REVIEWER_INFO: '/specialize-reviews/reviewer',
  GET_DETAIL: 'specialize-reviews/detail',
  CREATE: '/specialize-reviews',
  UPDATE: '/specialize-reviews',
  SUBMIT: '/specialize-reviews/submit',

  GET_DETAIL_FILE: '/specialize-reviews/detail/file-url',
  UPLOAD_DETAIL_FILE: '/specialize-reviews/upload-file',
  UPDATE_DETAIL_FILE: '/specialize-reviews/upload-file',
  DOWNLOAD_DETAIL_FILE: '/specialize-reviews/download-file',
  SUBMIT_DETAIL_FILE: '/specialize-reviews/submit',
  EXPORT_PDF_FILE: '/specialize-reviews/export-pdf-file',
  DOWNLOAD_PDF_FILE: '/specialize-reviews/pdf-file',
  DOWNLOAD_PDF_TEMPLATE: '/specialize-reviews/pdf-template',
  DOWNLOAD_DOCX_FILE: '/specialize-reviews/docx-file',
  DOWNLOAD_DOCX_TEMPLATE: '/specialize-reviews/docx-template',
};
// #endregion

// #region FINANCIAL_REVIEWS
export const FINANCIAL_REVIEW = {
  GET_INFO: '/financial-reviews/info',
  GET_DETAIL: 'financial-reviews/detail',
  CREATE: '/financial-reviews',
  UPDATE: (id) => `/financial-reviews/${id}`,
  SUBMIT: '/financial-reviews/submit',

  GET_DETAIL_FILE: '/financial-reviews/detail/file-url',
  UPLOAD_DETAIL_FILE: '/financial-reviews/upload-file',
  UPDATE_DETAIL_FILE: '/financial-reviews/upload-file',
  DOWNLOAD_DETAIL_FILE: '/financial-reviews/download-file',
  SUBMIT_DETAIL_FILE: '/financial-reviews/submit',
  EXPORT_PDF_FILE: '/financial-reviews/export-pdf-file',
  DOWNLOAD_PDF_FILE: '/financial-reviews/pdf-file',
  DOWNLOAD_PDF_TEMPLATE: '/financial-reviews/pdf-template',
  DOWNLOAD_DOCX_FILE: '/financial-reviews/docx-file',
  DOWNLOAD_DOCX_TEMPLATE: '/financial-reviews/docx-template',
};
// #endregion

// #region MIDTERM_REVIEWS
export const MIDTERM_REVIEW = {
  UPLOAD_DETAIL_FILE: '/midterm-reviews/upload-file',
  UPDATE_DETAIL_FILE: '/midterm-reviews/upload-file',

  GET_PROJECT_PROPOSAL_INFO: '/midterm-reviews/project-proposal',
  GET_REVIEWER_INFO: '/midterm-reviews/reviewer',
  GET_DETAIL_FILE: '/midterm-reviews/review/detail/file',
  GET_DETAIL: '/midterm-reviews/detail',

  CREATE_MIDTERM_REVIEW: '/midterm-reviews',
  UPDATE_MIDTERM_REVIEW: '/midterm-reviews',
  SUBMIT_MIDTERM_REVIEW: '/midterm-reviews/submit',

  DOWNLOAD_FILE: '/midterm-reviews/download-file',
  DOWNLOAD_PDF_FILE: '/midterm-reviews/pdf-file',
  DOWNLOAD_PDF_TEMPLATE: '/midterm-reviews/pdf-template',
  DOWNLOAD_DOCX_FILE: '/midterm-reviews/docx-file',
  DOWNLOAD_DOCX_TEMPLATE: '/midterm-reviews/docx-template',
};
// #region ACCEPTANCE_REVIEWS
export const ACCEPTANCE_REVIEW = {
  UPLOAD_DETAIL_FILE: '/acceptance-reviews/upload-file',
  UPDATE_DETAIL_FILE: '/acceptance-reviews/upload-file',
  CREATE_REVIEW: '/acceptance-reviews',
  UPDATE_REVIEW: '/acceptance-reviews',
  SUBMIT: '/acceptance-reviews/submit',

  GET_PROJECT_PROPOSAL_INFO: '/acceptance-reviews/project-proposal',
  GET_REVIEWER_INFO: '/acceptance-reviews/reviewer',
  GET_DETAIL_FILE: '/acceptance-reviews/review/detail/file',
  GET_DETAIL: '/acceptance-reviews/detail',

  DOWNLOAD_FILE: '/acceptance-reviews/download-file',
  DOWNLOAD_PDF_FILE: '/acceptance-reviews/download-pdf',
  DOWNLOAD_PDF_TEMPLATE: '/acceptance-reviews/download-pdf-template',
  DOWNLOAD_DOCX_FILE: '/acceptance-reviews/docx-file',
  DOWNLOAD_DOCX_TEMPLATE: '/acceptance-reviews/docx-template',
};

// #region ACCEPTANCE_REVIEWS
export const LIQUIDATION_REVIEW = {
  GET_REVIEWER_INFO: '/liquidation-reviews/reviewer',
};
// #endregion

// #region PROJECTS
export const PROJECTS = {
  GET_ALL: '/projects',
  GET_ALL_PROJECT_STATUS: '/projects/status',
  POST_CREATE: '/projects',
  SUBMIT_CONTRACT: (id) => `/projects/submit-project/${id}`,
  GET_GENERAL_INFO_FOR_COUNCIL: (id) => `/projects/general-info-for-council/${id}`,
  GET_PROJECT_BY_ID: (id) => `/projects/${id}`,
  GET_PROJECT_BY_PROJECT_PROPOSAL_ID: (projectProposalId) =>
    `/projects/projectProposalId/${projectProposalId}`,
  DELETE_PROJECT: (id) => `/projects/${id}`,
  RESTORE_PROJECT: (id) => `/projects/${id}/restore`,
  GET_PDF_FILE: (id) => `/projects/pdf-file/${id}`,
  POST_DOWNLOAD_PDF: '/projects/download-file',
  GET_DOCX_FILE: (id) => `/projects/docx-file/${id}`,
  GET_DOCX_BY_TEMPLATE: (projectProposalId) => `/projects/docx-by-template/${projectProposalId}`,
  POST_UPLOAD_PROJECT_FILES: '/projects/upload-project-files',
  POST_DELETE_PROJECT_FILES: '/projects/delete-project-files',
  EXPORT_EXCEL: '/projects/export-file-excel',
  SUM_UP: (id) => `/projects/general/${id}`,
  POST_HUMAN_RESOURCE: (projectProposalId) =>
    `/project-proposals/${projectProposalId}/adjust-member`,

  GET_ATTACHMENT: (id) => `/projects/${id}/attachments`,
  GET_ADJUSTMENTS_BY_ID: (id) => `/projects/${id}/adjustments`,

  DOWNLOAD_DOCX_HUMAN_RESOURCE_FILE: (projectProposalId) =>
    `/project-proposals/${projectProposalId}/adjust-member/docx-file`,
  DOWNLOAD_DOCX_TEMPLATE_HUMAN_RESOURCE_FILE: (projectProposalId) =>
    `/project-proposals/${projectProposalId}/adjust-member/docx-template`,
  DOWNLOAD_PDF_HUMAN_RESOURCE_FILE: (projectProposalId) =>
    `/project-proposals/${projectProposalId}/adjust-member/download-pdf`,
  DOWNLOAD_PDF_TEMPLATE_HUMAN_RESOURCE_FILE: (projectProposalId) =>
    `/project-proposals/${projectProposalId}/adjust-member/download-pdf-template`,
  GET_DATA_FOR_REGISTER_RESULT: (id) => `/projects/${id}/data-for-register-result`,
};

// #endregion

// #region SUMMARY_REPORT
export const SUMMARY_REPORT = {
  GET_SUMMARY_REPORT: (id) => `/summary-report/${id}`,
  CREATE_REPORT: '/summary-report',
  SUBMIT_REPORT: '/summary-report',
  UPDATE_REPORT: '/summary-report',
  PERMISSION_UPDATE_REPORT: '/summary-report/review',
  CREATE_REPORT_FILE: '/summary-report/upload-files',

  DOWNLOAD_REPORT_FILE: '/summary-report/download-file',
  GET_TYPE_SUMMARY_REPORT: '/summary-report/summary-report-types',
  GET_EXPENDITURE_TYPE_SUMMARY_REPORT: '/summary-report/summary-report-expenditure-types',
  DOWNLOAD_REPORT_PDF_FILE: '/summary-report/download-pdf',
  DOWNLOAD_REPORT_DOCX_FILE: '/summary-report/download-docx',

  GET_SUMMARY_REPORT_REVIEWS: (id) => `/summary-report/${id}/reviews`,
  CREATE_SUMMARY_REPORT_REVIEW: (id) => `/summary-report/${id}/reviews`,
  UPDATE_SUMMARY_REPORT_REVIEW: (id, reviewId) => `/summary-report/${id}/reviews/${reviewId}`,

  DOWNLOAD_ZIP: (id) => `/summary-report/${id}/zip`,
};
// #endregion

// #region LIQUIDATION_AGREEMENT
export const LIQUIDATION_AGREEMENT = {
  POST_LIQUIDATION: '/liquidation',
  GET_ALL_LIQUIDATION: '/projects',
  GET_LIQUIDATION_BY_ID: '/liquidation',
  SUBMIT_LIQUIDATION: (id) => `/liquidation/submit-liquidation/${id}`,
  UPLOAD_LIQUIDATION_FILES: '/liquidation/upload-liquidation-files',
  UPDATE_LIQUIDATION_FILES: '/liquidation/update-liquidation-files',
  DELETE_LIQUIDATION_FILES: '/liquidation/delete-liquidation-files',
  DOWNLOAD_FILE: '/liquidation/download-file',
};
// #endregion

// #region REGISTER_RESULT
export const REGISTER_RESULT = {
  GET_REGISTER_RESULT: '/register-results',
  GET_REGISTER_RESULT_BY_PROJECT_ID: (projectId) => `/register-results/${projectId}`,
  POST_REGISTER_RESULT: '/register-results',
  PATCH_REGISTER_RESULT: '/register-results',
  SUBMIT_REGISTER_RESULT: '/register-results/submit',
  GET_DETAIL_REGISTER_RESULT: (projectId) => `/register-results/profile/${projectId}`,
  DOWNLOAD_FILE: (id) => `/register-results/${id}/files`,
  CREATE_REVIEW: (id) => `/register-results/${id}/reviews`,
  UPDATE_REVIEW: (id, reviewId) => `/register-results/${id}/reviews/${reviewId}`,
  CHANGE_STATUS: (id) => `/register-results/${id}/status`,
  GET_REVIEWS: (id) => `/register-results/${id}/reviews`,
  GET_REVIEW_HISTORIES: (id) => `/register-results/${id}/review-histories`,
  DOWNLOAD_DOCX_TEMPLATE: '/register-results/docx-template',
  DOWNLOAD_DOCX_FILE: '/register-results/docx-file',
  DOWNLOAD_PDF_TEMPLATE: '/register-results/pdf-template',
  DOWNLOAD_PDF_FILE: '/register-results/pdf-file',
};
// #endregion

// #region EXTEND_IMPLEMENTATION_TIME
export const EXTEND_IMPLEMENTATION_TIME = {
  GET_ALL: '/extend-implementation-time/all',
  GET_ALL_VERSION: '/extend-implementation-time/all-version',
  REVIEW: (id) => `/extend-implementation-time/${id}/review`,
  GET_BY_ID: (id) => `/extend-implementation-time/${id}`,
  CREATE: '/extend-implementation-time',
  UPDATE: '/extend-implementation-time',
  SUBMIT: (id) => `/extend-implementation-time/submit/${id}`,
  DOWNLOAD_FILE: '/extend-implementation-time/download-file',
  DOWNLOAD_DOCX_FILE: '/extend-implementation-time/docx-file',
  DOWNLOAD_DOCX_TEMPLATE: '/extend-implementation-time/docx-template',
  DOWNLOAD_PDF_FILE: '/extend-implementation-time/download-pdf',
  DOWNLOAD_PDF_TEMPLATE: '/extend-implementation-time/download-pdf-template',
  UPLOAD_EXTEND_FILE: '/extend-implementation-time/upload-extend-files',
  DELETE_EXTEND_FILE: '/extend-implementation-time/delete-extend-time-files',
};
// #endregion

// #region BONUS_EXPENDITURE
export const BONUS_EXPENDITURE = {
  GET_ALL: '/bonus',
  GET_BY_ID: (id) => `/bonus/${id}`,
  CREATE: '/bonus',
  UPDATE: (id) => `/bonus/${id}`,
  DELETE: (id) => `/bonus/${id}`,
  RESTORE: (id) => `/bonus/${id}/restore`,
  GET_LIQUIDATION_BY_ID: '/liquidation',
  SUBMIT_LIQUIDATION: (id) => `/liquidation/submit-liquidation/${id}`,
  UPLOAD_LIQUIDATION_FILES: '/liquidation/upload-liquidation-files',
  UPDATE_LIQUIDATION_FILES: '/liquidation/update-liquidation-files',
  DELETE_LIQUIDATION_FILES: '/liquidation/delete-liquidation-files',
  DOWNLOAD_FILE: '/liquidation/download-file',
};
// #endregion

// #region FINANCIAL_ADJUSTMENT
export const FINANCIAL_ADJUSTMENT = {
  CREATE: '/financial-adjustments',
  UPDATE: (id) => `/financial-adjustments/${id}`,
  SUBMIT: (id) => `/financial-adjustments/${id}/submit`,
  REVIEW: (id) => `/financial-adjustments/${id}/review`,
  GET_ALL: (projectId) => `/financial-adjustments/${projectId}`,
  GET_BY_ID: (id) => `/financial-adjustments/${id}`,
  DOWNLOAD_PDF_FILE: (id) => `/financial-adjustments/pdf-file/${id}`,
  DOWNLOAD_DOCX_FILE: (id) => `/financial-adjustments/word-file/${id}`,
  DOWNLOAD_FILE: '/financial-adjustments/download-file',
};
// #endregion

// #region PROPOSALS
export const PROPOSALS = {
  CREATE: '/proposals',
  UPDATE: (id) => `/proposals/${id}`,
  GET_ALL: '/proposals',
  GET_BY_ID: (id) => `/proposals/${id}`,
  CHANGE_PROGRAM: (id) => `/proposals/${id}/program`,
  DELETE: (id) => `/proposals/${id}`,
  APPROVE: (id) => `/proposals/approve/${id}`,
  DOWNLOAD_ZIP: '/proposals/download-zip',
  DOWNLOAD_FILE: '/proposals/download-file',
  UPLOAD_FILE: (id) => `/proposals/${id}/upload`,
};
// #endregion

// #region REVIEWS
export const REVIEWS = {
  GET_REVIEWS_DETAIL: '/reviews/detail',
  GET_REVIEWER_INFO: '/reviews/reviewer',
  CREATE_REVIEW: '/reviews',
  UPDATE_REVIEW: '/reviews',
  SUBMIT_REVIEW: '/reviews/submit',
  DOWNLOAD_DOCX_FILE: '/reviews/docx-file',
  DOWNLOAD_DOCX_TEMPLATE: '/reviews/docx-template',
  DOWNLOAD_PDF_FILE: '/reviews/pdf-file',
  DOWNLOAD_PDF_TEMPLATE: '/reviews/pdf-template',
};
// #endregion

// #region PERSONNEL_ADJUSTMENTS
export const PERSONNEL_ADJUSTMENTS = {
  REVIEW: (id) => `/personnel-adjustments/${id}/review`,
  GET_BY_ID: (id) => `/personnel-adjustments/${id}`,
  GET_BY_PROJECT_ID: (projectId) => `/personnel-adjustments/project/${projectId}`,
  DOWNLOAD_DOCX_FILE: (id) => `/personnel-adjustments/${id}/docx`,
  DOWNLOAD_PDF_FILE: (id) => `/personnel-adjustments/${id}/pdf`,
};
// #endregion

// #region ADJUSTMENT_COMMENTS
export const ADJUSTMENT_COMMENTS = {
  CREATE: '/adjustment-comments',
  UPDATE: (id) => `/adjustment-comments/${id}`,
  GET_ALL: '/adjustment-comments',
  GET_BY_ID: (adjustmentId) => `/adjustment-comments/${adjustmentId}`,
};
// #endregion

// #region DASHBOARD
export const DASHBOARD = {
  PROJECT_PROPOSALS_REVIEW_STATUS: '/dashboard/project-proposals/review-status',
  GET_PROJECT_STATISTICS: '/dashboard/project/statistics',
  PROJECT_STATISTICS_YEARS: '/dashboard/project/statistics-year',
  GET_QUANTITY_STATISTICS: '/dashboard/project/proposal',
  PROJECT_PROPOSALS_EXPENDITURES: '/dashboard/project-proposals/expenditures',
};
// #endregion
